












































import Component from 'vue-class-component';

// Shared types
import { AdditionalProduct, ServiceProduct } from '@coldtec/cos-types';

// Store types
import { ProductsGetter, ToolProducts } from '@/store/store.types';

// Steps and step types
import Steps from '@/steps/steps';
import { Step } from '@/steps/types';

// The base class for every step
import BaseStep from '../BaseStep.vue';

// Product component
import Product from './internals/Product.vue';

/**
 *  The third step: selecting service and additional products.
 */
@Component({
    components: {
        Product,
    },
})
export default class ProductsStep extends BaseStep {

    /**
     *  Used to get all the additional (tool) products from the store, sorted on index.
     */
    private get additionalProducts(): ToolProducts<AdditionalProduct> {

        return this.$store.getters[ProductsGetter.ADDITIONAL];

    }

    /**
     *  Used to get all the service (tool) products from the store, sorted on index.
     */
    private get serviceProducts(): ToolProducts<ServiceProduct> {

        return this.$store.getters[ProductsGetter.SERVICE];

    }

    /**
     *  Reset the footer's floating action and next button when created.
     */
    private created(): void {

        /**
         *  Ensure there's no floating action set.
         */
        this.setFooterFloatingAction(null);

        /**
         *  Update the footer next accordingly.
         */
        this.setFooterNext({
            step: Steps[Step.Overview],
            disabled: false,
            action: () => {

                void this.$router.push(Step.Overview);

            },
        });

    }

    /**
     *  Invoke the base step's mounted hook when mounted.
     */
    private mounted(): void {

        this.stepMounted();

    }

}
